<div class="dialog-container">
  <div class="dialog-header">
    <span class="main-text"> Rename </span>
  </div>
  <div class="dialog-content">
    <mat-form-field appearance="outline" class="mat-field-custom">
      <mat-label>Name</mat-label>
      <input
        matInput
        [(ngModel)]="data.name"
        placeholder="Enter text"
        (keyup.enter)="save(data.name)"
        #titleInput
      />
    </mat-form-field>
  </div>
  <div class="dialog-actions">
    <button mat-stroked-button (click)="cancel()">Cancel</button>
    <button
      class="primary-btn"
      mat-flat-button
      (click)="save(data.name)"
      [disabled]="!data.name?.trim()"
    >
      Rename
    </button>
  </div>
</div>
